import * as React from "react"

const Language = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.001 18.834a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z"
    />
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.667 3H7.5a23.686 23.686 0 0 0 0 15h-.833M12.5 3a23.686 23.686 0 0 1 0 15"
    />
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.5 13.833V13a23.686 23.686 0 0 0 15 0v.833M2.5 8a23.686 23.686 0 0 1 15 0"
    />
  </svg>
)
export default Language
